export function enableFormAttributes() {
    try 
    {          
        $("form[data-disable-onsubmit]").on("submit", function(event:JQuery.Event) {
            console.log(`[form-attribute] submit called`, this);

            let selector = $(this).attr('data-disable-onsubmit');
            if (!selector) { selector = "[type='submit']";}                     

            const controls = $(selector);

            console.log(`[form-attribute] disabling controls on submit`);
            controls.prop('disabled', true);
          
            // Dependent on this custom event sent from customized jquery-validation because
            // the whole invalid-form event in jquery-validation is gobbled up by unobtrustive.. irony 
            document.addEventListener('form-invalid', function (customEvent) {
                console.log("form-validation prevented submit, reenabling controls");
                controls.prop('disabled', false);
            });          
        });

    } catch (ex) {
        console.error(ex);
    }

    console.log("[app-behaviors] Installed form-attributes behavior (data-disable-onsubmit='.mybutton')");
}